var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapFooter = function SvgMapFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 0C2.467 0 0 2.333 0 5.197-.02 9.386 5.291 12.86 5.5 13c0 0 5.52-3.614 5.5-7.8C11 2.333 8.533 0 5.5 0m0 7.8c-1.52 0-2.75-1.163-2.75-2.6 0-1.436 1.23-2.6 2.75-2.6s2.75 1.164 2.75 2.6S7.02 7.8 5.5 7.8"
  })));
};
export default SvgMapFooter;